import { axios } from '@Root/API'

export const getRelated = () => {
	return axios.get(`data-institutions-for-select`)
}
